export const environment = {
  production: false,
  type: 'staging',
  apiURL: 'https://staging-customizer-api-demo.benchmarkrings.com',
  assetsURL: 'https://bmstoragenew.blob.core.windows.net',
  b2bURL: 'http://b2bv220230406110603-staging.azurewebsites.net/',
  thumbnailServiceURL: 'https://images-demo.benchmarkrings.com',
  awsURL: 'https://assets.benchmarkrings.com/benchmark_rings',
  gaTrackingID: '',
  iframeGATrackingID: '',
  maxCompareVisibilityCount: 3,
  openReplayKey: 'cQxIUmDVbAmz3Zf6EUil',
  openReplayIframeKey: 'Eo6BtmtyByfd97ECGxoI',
  openReplayIngestPoint: 'https://benchmark.us.openreplay.cloud/ingest',
  b2bSearchPath: '/#/search/stylenumber/'
};
